module.exports = __webpack_public_path__ + "static/media/debian.2c88576b.png";